import { Grid, Typography, Button, Box } from "@mui/material";
import { camelCaseToItalicSpaced } from "features/common/utils/textTransform";
import { NavButtonConfig, NavMenuConfig } from "./NavMenu.types";
import { UploadButton } from "../UploadButton";

export interface NavMenuProps {
  config: NavMenuConfig;
  onClick: (btnConfig: NavButtonConfig) => () => void;
}

export const NavMenu = ({ config, onClick }: NavMenuProps) => {
  return (
    <Grid container>
      {Object.entries(config).map(([submenuName, btnConfigList]) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          lg={3}
          sx={{ textAlign: "center" }}
          key={submenuName}
        >
          <Typography
            variant="h6"
            color="white"
            noWrap
            sx={{
              flexGrow: 1,
              backgroundColor: "primary.main",
              marginBottom: "10px",
            }}
          >
            {camelCaseToItalicSpaced(submenuName)}
          </Typography>
          {btnConfigList.map((btnConfig) => (
            <Box key={btnConfig.label}>
              {btnConfig.openExplorer ? (
                <UploadButton>
                  <Typography noWrap>{btnConfig.label}</Typography>
                </UploadButton>
              ) : (
                <Button
                  color="secondary"
                  variant="outlined"
                  component="span"
                  onClick={onClick(btnConfig)}
                  sx={{
                    borderRadius: 0,
                    textTransform: "none",
                    fontWeight: "bold",
                    width: "90%",
                    marginBottom: "20px",
                  }}
                >
                  <Typography noWrap>{btnConfig.label}</Typography>
                </Button>
              )}
              <br />
            </Box>
          ))}
        </Grid>
      ))}
    </Grid>
  );
};
